import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

type ThisApi = ApiDefinition['/invoices/{id}/withVersion']['PUT'];

type Input = ThisApi['params'] & ThisApi['body'];
type Output = ThisApi['response'];

const updateInvoiceWithVersion = async ({ id, ...body }: Input): Promise<Output> => {
  const path = buildPath<ThisApi>('/invoices/{id}/withVersion', { id });
  const response = await noodleApiClient.put(path, body);
  return response.data;
};

export default updateInvoiceWithVersion;
